import React, { forwardRef } from "react";
import { bool, node } from "prop-types";

import * as S from "./styled";

const FilterChip = forwardRef((props, ref) => (
  <S.FilterChip ref={ref} {...props} />
));

FilterChip.propTypes = {
  children: node.isRequired,
  hideIcon: bool
};

FilterChip.defaultProps = {
  hideIcon: false
};

export default FilterChip;
